import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Lock } from "lucide-react";
import { PublicNavbar } from "@/components/layout/PublicNavbar";
import { Footer } from "@/components/layout/Footer";
import { StatusBadge } from "@/components/shared/StatusBadge";
import { api } from "@/lib/api";

export default function SampleDeal() {
  const [deal, setDeal] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/deals/public-sample").then((r) => setDeal(r.data));
  }, []);

  if (!deal) {
    return (
      <div className="min-h-screen bg-background">
        <PublicNavbar />
        <div className="max-w-[1000px] mx-auto px-6 py-20 text-muted-foreground">Loading…</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <PublicNavbar />
      <div className="max-w-[1000px] mx-auto px-6 md:px-8 py-14">
        <button onClick={() => navigate("/")} className="text-sm text-muted-foreground hover:text-foreground" data-testid="back-to-landing">← Back</button>

        <div className="mt-6 flex items-center gap-3">
          <span className="overline gold-text">Sample Intelligence</span>
          <StatusBadge status={deal.status} />
        </div>
        <h1 className="font-display font-medium text-4xl md:text-5xl mt-3 tracking-tight">{deal.title}</h1>
        <p className="mt-3 text-sm text-muted-foreground">{deal.country} · {deal.sector.replaceAll("_", " ")}</p>

        <div className="divider my-8" />

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { k: "Size", v: deal.size_usd },
            { k: "Tenor", v: deal.tenor },
            { k: "Return", v: deal.return_text },
            { k: "Min Ticket", v: deal.min_ticket },
          ].map((m) => (
            <div key={m.k}>
              <div className="overline">{m.k}</div>
              <div className="font-mono text-lg md:text-xl mt-2">{m.v}</div>
            </div>
          ))}
        </div>

        <div className="divider my-8" />

        <section>
          <h2 className="font-display font-medium text-xl mb-3">Overview</h2>
          <p className="text-muted-foreground leading-relaxed">{deal.overview}</p>
        </section>

        <section className="mt-10">
          <h2 className="font-display font-medium text-xl mb-4">Structure</h2>
          <div className="card-institutional p-6">
            <p className="text-sm mb-5">{deal.structure}</p>
            <div className="flex items-center gap-2 flex-wrap">
              {deal.structure_flow?.map((n, i) => (
                <React.Fragment key={n}>
                  <div className="px-4 py-2 border border-border rounded text-xs font-mono">{n}</div>
                  {i < deal.structure_flow.length - 1 && <ArrowRight className="h-4 w-4 gold-text" />}
                </React.Fragment>
              ))}
            </div>
          </div>
        </section>

        <section className="mt-10 card-institutional p-8 text-center relative overflow-hidden">
          <Lock className="h-6 w-6 gold-text mx-auto mb-4" strokeWidth={1.5} />
          <h3 className="font-display font-medium text-xl mb-2">Pricing insight, risks & execution path are for members.</h3>
          <p className="text-sm text-muted-foreground mb-6 max-w-md mx-auto">
            Unlock the full breakdown including mispricing analysis, counterparty matrix, and entry timeline.
          </p>
          <button onClick={() => navigate("/auth")} className="btn-primary" data-testid="sample-request-access">
            Request Access <ArrowRight className="h-4 w-4" />
          </button>
        </section>
      </div>
      <Footer />
    </div>
  );
}
